import React from "react";

const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-sm fixed top-0 left-0 w-full z-50">
      <div className="flex items-center justify-between px-4 py-3 max-w-md mx-auto">
        <h1 className="text-lg font-medium text-gray-900">Due Diligence</h1>
        <button
          id="close-btn"
          className="text-gray-600 hover:text-gray-900"
          onClick={() => {
            window.parent.postMessage(
              JSON.stringify({
                status: "close",
                message: "close iframe",
              }),
              "*"
            );
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
